import Loadable from '../../components/loadable';

const BulkImportMultipleSelect = Loadable({
  loader: () => import('../../pages/bulk_imports/bulk_import_membership_plans_multi_select'),
});

angular.module('gym').value('BulkImportMultipleSelect', BulkImportMultipleSelect);
